<div class="column">
  <div class="search-bar">
    <mat-form-field appearance="outline" class="status-search">
      <mat-label>Status</mat-label>

      <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryStatus && queryStatus !=='*'">
          <app-status-indicator [isDropdownOption]="true" [statusText]="queryStatus"></app-status-indicator>
        </mat-select-trigger>
        <mat-option value="*"><mat-icon [svgIcon]="icons.FilterOffIcon" /> <span
            style="margin-left: 16px;">All</span></mat-option>
        <mat-option value="ACTIVE"><app-status-indicator [isDropdownOption]="true"
            statusText="Active"></app-status-indicator></mat-option>
        <mat-option value="CLOSED"><app-status-indicator [isDropdownOption]="true"
            statusText="Closed"></app-status-indicator></mat-option>
        <mat-option value="INACTIVE"><app-status-indicator [isDropdownOption]="true"
            statusText="Inactive"></app-status-indicator></mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="user-type-search">
      <mat-label>Customer type</mat-label>
      <mat-select [(ngModel)]="queryCustomerType" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryCustomerType">
          {{EnrollmentTypeStrMap.get(queryCustomerType)}}
        </mat-select-trigger>
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let userType of userTypes" [value]="userType">
          {{EnrollmentTypeStrMap.get(userType)}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search--input">
      <mat-label>Custom Search</mat-label>
      <mat-icon matPrefix class="search-hint-icon"
                matTooltip="Search customers by name, email, account ID or phone number. Type at least 3 characters."
                matTooltipPosition="above">info_outline</mat-icon>
      <input matInput type="text" placeholder="Custom Search" [(ngModel)]="query" (ngModelChange)="onFilter()">
      @if (query) {
      <button matSuffix mat-icon-button aria-label="close" (click)="clearSerch()">
        <mat-icon>close</mat-icon>
      </button>
      } @else {
      <button matSuffix mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
      }
    </mat-form-field>
  </div>
  <div class="row">
    <app-filter-tag-container (onClearAll)="removeFilters()" (onRemoveTag)="removeFilter($event)" />
  </div>
  <div class="mat-elevation-z8">
    <table mat-table class="full-width-table" matSort aria-label="Elements">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
        <td mat-cell *matCellDef="let row">{{row.id}}</td>
      </ng-container>
      <ng-container matColumnDef="entityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">{{row.entityName}}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Customer Type</th>
        <td mat-cell *matCellDef="let row">
          <app-enrollment-type-indicator
            [enrollmentType]="EnrollmentTypeStrMap.get(row.type)"></app-enrollment-type-indicator>
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email Address</th>
        <td mat-cell *matCellDef="let row">{{row.email}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <app-status-indicator [statusText]="row.status"></app-status-indicator>
        </td>
      </ng-container>




      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
        [routerLink]="['/app/search/customer/', row.id]"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No data matching the filter.
        </td>
      </tr>
    </table>

    <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
    </mat-paginator>
  </div>
</div>
